import { connect } from 'react-redux'
import ProfileUI from './ProfileUI'
import { Dispatch } from 'redux';
import ApplicationState from '../../../../../../ApplicationState';
import HomeState from '../../../../State/HomeState';
import IState from '../../../../../Util/IState';
import ProfileDispatch from './model';
import IDispatcher from '../../../../../Util/IDispatcher';
import { ActionType as HomeAction } from '../../../../Actions/ActionTypes';
import { ActionType } from '../../../Main/Router/Actions/ActionTypes';



const mapStateToProps = (state: ApplicationState): IState<HomeState> => {
    return {
        state: state.home
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<ProfileDispatch> => ({
    dispatcher: {
        payments: () => { dispatch({type : ActionType.MAIN_UI_PAYMENT_HISTORY}) },
        orders: () => { dispatch({type : ActionType.MAIN_UI_ORDER_HISTORY}) },
        main: () => { dispatch({type : ActionType.MAIN_UI_DASHBOARD}) },
        profile :(isShow : boolean) =>{ dispatch({type : HomeAction.SHOW_USER_PROFILE , open : isShow}) },
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUI)